<template>
    <div class="mt-4 md:-mt-12">
        <div class="md:flex items-stretch">
            <div
                class="md:w-1/3 my-2 md:mx-1 p-2 bg-white shadow rounded text-sm border-b-4 md:border-l-4 md:border-b-0 border-primary-lighter"
            >
                <div class="h-full flex flex-col">
                    <p class="my-2 uppercase font-bold text-xs">VIP List</p>
                    <p class="flex-1 text-gray-darker">
                        You have
                        <strong class="text-black">{{ vipSummary }}</strong> in
                        your VIP List.
                    </p>
                    <p class="my-2">
                        <a
                            href="/settings#vip"
                            class="py-1 rounded text-primary font-bold underline"
                            >Manage VIPs</a
                        >
                    </p>
                </div>
            </div>
            <div
                class="md:w-1/3 my-2 md:mx-1 p-2 bg-white shadow rounded text-sm border-b-4 md:border-l-4 md:border-b-0 border-primary-lighter"
            >
                <div class="h-full flex flex-col">
                    <p class="my-2 uppercase font-bold text-xs">Delivery</p>
                    <p class="flex-1 text-gray-darker">
                        Your emails are delivered
                        <strong
                            class="text-black"
                            v-if="hasCustomWeeklySchedule"
                            >at a custom weekly schedule</strong
                        >
                        <strong class="text-black" v-else
                            >{{ slots.length }} times a day</strong
                        >.
                        <span v-if="dnd.starts_at !== null"
                            >You have DND
                            <strong class="text-black"
                                >between {{ dnd.starts_at }} -
                                {{ dnd.ends_at }}</strong
                            >.</span
                        >
                        <span v-else>You do not have any DND period set.</span>
                        <span v-if="summarySlot !== null"
                            >Daily summary will be sent at
                            <strong class="text-black">{{ summarySlot }}</strong
                            >.</span
                        >
                        <span v-else>Daily summary is disabled.</span>
                    </p>
                    <p class="my-2">
                        <a
                            href="/settings#delivery"
                            class="py-1 rounded text-primary font-bold underline"
                            >Manage delivery</a
                        >
                    </p>
                </div>
            </div>
            <div
                class="md:w-1/3 my-2 md:mx-1 p-2 bg-white shadow rounded text-sm border-b-4 md:border-l-4 md:border-b-0 border-primary-lighter"
            >
                <div class="h-full flex flex-col">
                    <p class="my-2 uppercase font-bold text-xs">Daily Digest</p>
                    <p class="flex-1 text-gray-darker">
                        Emails that are held back from your inbox. You can
                        review them now and teach Mailman how to handle similar
                        emails in the future.
                    </p>
                    <p class="my-2 font-bold" v-if="isFilteringSpam">
                        <span v-if="zappedEmailsCount > 0"
                            ><a
                                href="/reviewer"
                                class="py-1 rounded text-primary underline"
                                >Review {{ zappedEmailsCount }} emails</a
                            ></span
                        >
                        <span v-else>Yay! No reviews pending.</span>
                    </p>
                    <p class="my-2 font-bold" v-else>
                        Turned off.
                        <a
                            href="/reviewer"
                            class="py-1 rounded text-primary underline"
                            >Turn ON.</a
                        >
                    </p>
                </div>
            </div>
            <!-- <div
                class="md:w-1/3 my-2 md:mx-1 p-2 bg-white shadow rounded text-sm border-b-4 md:border-l-4 md:border-b-0 border-primary-lighter"
            >
                <div class="h-full flex flex-col">
                    <p class="my-2 uppercase font-bold text-xs">Magazines</p>
                    <p class="flex-1 text-gray-darker">
                        Batch your newsletters into neat magazines and get them
                        delivered at your preferred day and time.
                    </p>
                    <p class="my-2">
                        <a
                            class="py-1 rounded text-primary font-bold underline"
                            href="/magazines"
                            >Manage magazines</a
                        >
                    </p>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            vips: {
                domains: [],
                addresses: [],
                keywords: [],
            },
            slots: [],
            dnd: {
                starts_at: null,
                ends_at: null,
            },
            summarySlot: "",
            zappedEmailsCount: 0,
            magazineCount: 0,
            isFilteringSpam: true,
            hasCustomWeeklySchedule: false,
        };
    },
    computed: {
        vipSummary() {
            let domainsText =
                this.vips.domains.length === 1 ? "domain" : "domains";
            let addressesText =
                this.vips.addresses.length === 1
                    ? "email address"
                    : "email addresses";
            let keywordsText =
                this.vips.keywords.length === 1 ? "keyword" : "keywords";
            return `${this.vips.domains.length} ${domainsText}, ${this.vips.addresses.length} ${addressesText} and ${this.vips.keywords.length} ${keywordsText}`;
        },
    },
    mounted() {
        axios
            .get(`/api/mailbox`)
            .then((response) => {
                this.vips = response.data.data.whitelists;
                this.slots = response.data.data.slots;
                this.dnd = response.data.data.dnd;
                this.summarySlot = response.data.data.summary;
                this.isFilteringSpam = response.data.data.is_filtering_spam;
                this.hasCustomWeeklySchedule =
                    response.data.data.has_custom_weekly_schedule;
            })
            .catch((err) => {
                console.error(err);
            });

        axios
            .get(`/api/messages?page=1`)
            .then((response) => {
                this.zappedEmailsCount = response.data.meta.total;
            })
            .catch((err) => {
                console.error(err);
            });

        axios
            .get(`/api/magazines`)
            .then((response) => {
                this.magazineCount = response.data.data.length;
            })
            .catch((err) => {
                console.error(err);
            });
    },
};
</script>

<style></style>
